<template>
<div>
	<p v-show="!isNotSubmit">
		Thank you for submitting. We will contact you at the earliest opportunity.
	</p>
	<div v-show="isNotSubmit">
		<form @submit.prevent="submitForm">
			<div class="mb-3">
				<label for="Name" class="form-label">Name</label>
				<input type="text" class="form-control" id="Name" placeholder="John Smith" v-model="EmailData.name">
			</div>
			<div class="mb-3">
				<label for="Subject" class="form-label">Subject</label>
				<textarea class="form-control" id="Subject" rows="1" v-model="EmailData.subject"></textarea>
			</div>
			<div class="mb-3">
				<label for="Text" class="form-label">Message</label>
				<textarea class="form-control" id="Text" rows="3" v-model="EmailData.text"></textarea>
			</div>
			<button class="btn btn-success" type="submit"> 
				Send
			</button>
		</form>
	</div>
</div>
</template>

<script>

export default {
	name: 'ContactForm',
	props: {
	},
	data() {
		return {
			EmailData: {
				name: '',
				subject: '',
				text: '',
				token: ''
			},
			isNotSubmit: true
		}

	},
	methods: {
		submitForm() {
			this.$recaptcha("login").then((token) => {
				this.EmailData['g-recaptcha-response'] = token;

				this.$axios.post("/captcha", this.EmailData)
				.then((response) => {
					if (response) {
						this.isNotSubmit = false
					}
				})
				.catch((err) => {
					console.log('Error sending email:', err)
				})
			})

		}
	}
}
</script>

<style>

</style>